import { useAbGroup } from '@/app/providers/ConfigProvider';
import { isUserInSubProjectBoxReplaceGroup } from '@/app/utils/abTesting/project-detail';
import { useMemo } from 'react';

export const useIsUserInSubProjectBoxReplaceGroup = () => {
  const abGroup = useAbGroup();

  return useMemo(() => isUserInSubProjectBoxReplaceGroup(abGroup), [abGroup]);
};
